import {
  FundSource,
  FundSourceFilter,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import {
  GetAllCitiesResponse,
  GetCategoriesResponse,
  type GetFundSourceFilterMapRequest,
  GetFundSourceFilterMapResponse,
  GetFundSourceFilterMapResponse_FundSourceFilterList,
  GetMyBalancesResponse,
  type PayRequest,
  PayResponse,
} from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import { getTenantSlug } from "../utils";

export function handleGetMyBalances() {
  const slug = getTenantSlug();
  if (slug === "marumori") {
    return new GetMyBalancesResponse({
      balanceWithFundSources: [
        {
          userBalance: {
            addId: "0191f997-35db-7d43-a6a0-652120513df6",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(2000),
            expireAt: {
              seconds: BigInt(1740754799),
              nanos: 0,
            },
          },
          fundSource: new FundSource({
            id: "0191f997-b5fc-7732-9303-a06f08183c09",
            name: "新規登録ポイント",
            priorityWeight: BigInt(1),
            forbidTransfer: false,
          }),
        },
      ],
    });
  }
  if (slug === "miyagi") {
    // 2030年2月末の有効期限（2030-02-28 23:59:59 UTC）
    const expireAt2030Feb = {
      seconds: BigInt(1898863199),
      nanos: 0,
    };

    // 1週間後の有効期限
    const oneWeekFromNow = new Date();
    oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);
    oneWeekFromNow.setHours(23, 59, 59, 999);
    const expireAtOneWeek = {
      seconds: BigInt(Math.floor(oneWeekFromNow.getTime() / 1000)),
      nanos: 0,
    };

    // 2週間後の有効期限
    const twoWeeksFromNow = new Date();
    twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14);
    twoWeeksFromNow.setHours(23, 59, 59, 999);
    const expireAtTwoWeeks = {
      seconds: BigInt(Math.floor(twoWeeksFromNow.getTime() / 1000)),
      nanos: 0,
    };

    // 2種類のポイントを返すケース
    // return new GetMyBalancesResponse({
    //   balanceWithFundSources: [
    //     {
    //       userBalance: {
    //         addId: "0191f998-35db-7d43-a6a0-652120513df1",
    //         userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
    //         amount: BigInt(2000),
    //         expireAt: expireAt2030Feb,
    //       },
    //       fundSource: new FundSource({
    //         id: "point-lottery",
    //         name: "新規登録ポイント",
    //         priorityWeight: BigInt(1),
    //         forbidTransfer: false,
    //       }),
    //     },
    //     {
    //       userBalance: {
    //         addId: "0191f998-35db-7d43-a6a0-652120513df3",
    //         userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
    //         amount: BigInt(200),
    //       },
    //       fundSource: new FundSource({
    //         id: "sample-point-200pt",
    //         name: "友達紹介ポイント",
    //         priorityWeight: BigInt(3),
    //         forbidTransfer: false,
    //       }),
    //     },
    //   ],
    // });

    return new GetMyBalancesResponse({
      balanceWithFundSources: [
        {
          userBalance: {
            addId: "0191f998-35db-7d43-a6a0-652120513df1",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(2000),
            expireAt: expireAt2030Feb,
          },
          fundSource: new FundSource({
            id: "point-lottery",
            name: "新規登録ポイント",
            priorityWeight: BigInt(1),
            forbidTransfer: false,
          }),
        },
        {
          userBalance: {
            addId: "d68e1467-6ffd-4c99-964f-df2a38f94b81",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(1000),
            expireAt: expireAtTwoWeeks,
          },
          fundSource: new FundSource({
            id: "point-lottery",
            name: "新規登録ポイント",
            priorityWeight: BigInt(1),
            forbidTransfer: false,
          }),
        },
        {
          userBalance: {
            addId: "0191f998-35db-7d43-a6a0-652120513df2",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(1000),
            expireAt: expireAt2030Feb,
          },
          fundSource: new FundSource({
            id: "mutual-aid-point-1000pt",
            name: "互助会ポイント",
            priorityWeight: BigInt(2),
            forbidTransfer: false,
          }),
        },
        {
          userBalance: {
            addId: "0191f998-35db-7d43-a6a0-652120513df3",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(200),
          },
          fundSource: new FundSource({
            id: "sample-point-200pt",
            name: "友達紹介ポイント",
            priorityWeight: BigInt(3),
            forbidTransfer: false,
          }),
        },
        {
          userBalance: {
            addId: "0191f998-35db-7d43-a6a0-652120513df4",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(500),
            expireAt: expireAtOneWeek,
          },
          fundSource: new FundSource({
            id: "expiring-point",
            name: "期限切れ間近ポイント",
            priorityWeight: BigInt(10), // 有効期限が近いため優先度を高く設定
            forbidTransfer: false,
          }),
        },
        {
          userBalance: {
            addId: "0191f998-35db-7d43-a6a0-652120513df5",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(300),
            expireAt: expireAt2030Feb,
          },
          fundSource: new FundSource({
            id: "non-transferable-point",
            name: "譲渡不可ポイント",
            priorityWeight: BigInt(4),
            forbidTransfer: true,
            note: "本人のみ利用可能",
          }),
        },
        {
          userBalance: {
            addId: "94d062f0-838c-4fd2-90b4-1bc4c7d7e618",
            userId: "0191f997-54e2-7b21-b9fd-f14fb7695bf9",
            amount: BigInt(8888),
            expireAt: expireAt2030Feb,
          },
          fundSource: new FundSource({
            id: "extra-long-point-name",
            name: "地域コミュニティ未来創造超ロングネーミングスペシャルボーナスポイントキャンペーン2025特別増量分",
            priorityWeight: BigInt(5),
            forbidTransfer: false,
            note: "表示テスト用に名前を長く設定しています",
          }),
        },
      ],
    });
  }
  return new GetMyBalancesResponse({
    balanceWithFundSources: [],
  });
}

export function handleGetCategories() {
  return new GetCategoriesResponse({
    categories: [
      "スーパー",
      "コンビニ",
      "ドラッグストア",
      "ガソリンスタンド",
      "その他の専門店",
      "飲食店",
      "居酒屋",
      "ホテル・旅館",
      "その他のサービス業",
    ],
  });
}

export function handleGetAllCities() {
  const slug = getTenantSlug();
  if (slug === "marumori") {
    return new GetAllCitiesResponse({
      cities: ["宮城県伊具郡丸森町"],
    });
  }
  if (slug === "shiga-otsu") {
    return new GetAllCitiesResponse({
      cities: [],
    });
  }
  return new GetAllCitiesResponse({
    cities: [
      "宮城県仙台市青葉区",
      "宮城県仙台市宮城野区",
      "宮城県仙台市若林区",
      "宮城県仙台市太白区",
      "宮城県仙台市泉区",
      "宮城県石巻市",
      "宮城県塩竈市",
      "宮城県気仙沼市",
      "宮城県白石市",
      "宮城県名取市",
      "宮城県角田市",
      "宮城県多賀城市",
      "宮城県岩沼市",
      "宮城県登米市",
      "宮城県栗原市",
      "宮城県東松島市",
      "宮城県大崎市",
      "宮城県富谷市",
      "宮城県刈田郡蔵王町",
      "宮城県刈田郡七ヶ宿町",
      "宮城県柴田郡大河原町",
      "宮城県柴田郡村田町",
      "宮城県柴田郡柴田町",
      "宮城県柴田郡川崎町",
      "宮城県伊具郡丸森町",
      "宮城県亘理郡亘理町",
      "宮城県亘理郡山元町",
      "宮城県宮城郡松島町",
      "宮城県宮城郡七ヶ浜町",
      "宮城県宮城郡利府町",
      "宮城県黒川郡大和町",
      "宮城県黒川郡大郷町",
      "宮城県黒川郡大衡村",
      "宮城県加美郡色麻町",
    ],
  });
}

export function handleGetFundSourceFilterMap(
  req: GetFundSourceFilterMapRequest,
) {
  const slug = getTenantSlug();

  if (slug !== "miyagi") {
    return new GetFundSourceFilterMapResponse({
      filterMap: {},
    });
  }

  const filtersByFundSourceId: Record<
    string,
    GetFundSourceFilterMapResponse["filterMap"][string]
  > = {
    "mutual-aid-point-1000pt":
      new GetFundSourceFilterMapResponse_FundSourceFilterList({
        filters: [
          new FundSourceFilter({
            fundSourceId: "mutual-aid-point-1000pt",
            availableStoreId: "0191f9f7-3047-795d-af14-2146e59151eb",
            availableCity: "宮城県仙台市青葉区",
          }),
        ],
      }),
    "sample-point-200pt":
      new GetFundSourceFilterMapResponse_FundSourceFilterList({
        filters: [
          new FundSourceFilter({
            fundSourceId: "sample-point-200pt",
            availableCity: "宮城県仙台市青葉区",
          }),
        ],
      }),
    "expiring-point": new GetFundSourceFilterMapResponse_FundSourceFilterList({
      filters: [
        new FundSourceFilter({
          fundSourceId: "expiring-point",
          availableStoreId: "0191fa0d-1ef4-7303-b2db-d580b98d1169",
          availableCity: "宮城県仙台市青葉区",
        }),
      ],
    }),
    "extra-long-point-name":
      new GetFundSourceFilterMapResponse_FundSourceFilterList({
        filters: [
          new FundSourceFilter({
            fundSourceId: "extra-long-point-name",
            availableCity: "宮城県仙台市泉区",
          }),
        ],
      }),
  };

  const requestedFundSourceIds = req.query?.fundSourceIds ?? [];

  return new GetFundSourceFilterMapResponse({
    filterMap: Object.fromEntries(
      requestedFundSourceIds
        .map((fundSourceId) => [
          fundSourceId,
          filtersByFundSourceId[fundSourceId],
        ])
        .filter((entry): entry is [string, NonNullable<(typeof entry)[1]>] =>
          Boolean(entry[1]),
        ),
    ),
  });
}

export function handlePay(req: PayRequest) {
  // トランザクション詳細を作成
  const transactionDetails = req.paymentDetails.map((detail) => {
    return {
      transaction: {
        id: `txn-${Math.random().toString(36).substring(2, 10)}`,
        groupId: "1",
        userId: "1",
        type: Transaction_Type.PAYMENT,
        balanceAddId: "1",
        amount: BigInt(-Number(detail.amount)),
        fundSourceId: detail.fundSourceId,
        reason: "支払い",
        qrId: req.qrId,
        createdAt: {
          seconds: BigInt(Math.floor(Date.now() / 1000)),
          nanos: 0,
        },
      },
      store: {
        id: req.storeId,
        name: "みやポマート",
        fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
        city: "宮城県仙台市青葉区",
        iconUrl: "/misc/icons/company.png",
        location: {
          latitude: 38.25783587179756,
          longitude: 140.87284595831724,
        },
      },
    };
  });

  return new PayResponse({
    transactionGroup: {
      id: `grp-${Math.random().toString(36).substring(2, 10)}`,
      transactionDetails,
    },
  });
}
